import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function orderSourceReducer(state = initialState.orderSource, action) {
  switch (action.type) {
    case types.SET_ORDER_SOURCE: {
      return action.orderSource;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/orderSource.reducer.js